<i18n>
en:
  area:
    label1: "Prefectures"
    label2: "Area"
    label3: "Area details"
    present: "Present location"
  checkin:
    label: "Check-in"
  checkout:
    label: "Check-out"
  luggage:
    label: "Luggage"
    unit: " "
  submit: "Search"
  covid19: "Due to the influence of COVID-19, the service provision has been suspended."
ja:
  area:
    label1: "都道府県"
    label2: "エリア"
    label3: "詳細"
    present: "現在地"
  checkin:
    label: "チェックイン"
  checkout:
    label: "チェックアウト"
  luggage:
    label: "荷物"
    unit: "個"
  submit: "検索"
  covid19: "COVID-19（コロナウィルス）の影響により、サービス提供を中断しています。"
</i18n>

<template lang="pug">
  div.search(:class="{'flow-mode': isFlow}")
    v-container.search-container
      v-row(justify="center")
        v-alert(outline color="warning" icon="fa-circle-exclamation")
          h2|{{$t('covid19')}}
      //- v-row(justify="center").search-content
        //- エリア
        v-col.d-flex(cols="12" sm="4" md="4")
          v-select(hide-details :label="$t('area.label1')" prepend-icon="fa-map-marked" :items="areaList1" item-text="areaName" return-object v-model="forms.area1" :loading="this.$store.getters.area_list.length === 0")
        v-col.d-flex.pl-11.pl-sm-0(cols="12" sm="4" md="4")
          v-select(hide-details :label="$t('area.label2')" :items="areaList2" item-text="areaName" return-object v-model="forms.area2" :disabled="areaList2.length === 0")
        v-col.d-flex.pl-11.pl-sm-0(cols="12" sm="4" md="4")
          v-select(hide-details :label="$t('area.label3')" :items="areaList3" item-text="areaName" return-object v-model="forms.area3" :disabled="areaList3.length === 0")

        //- 期間
        v-col.d-flex(cols="12" sm="4" md="4")
          v-menu(offset-y transition="scale-transition" :nudge-right="40" min-width="290px" :close-on-content-click="false" v-model="calendar1")
            template(v-slot:activator="{on}")
              v-text-field(hide-details :label="$t('checkin.label')" prepend-icon="fa-calendar-alt" v-on="on" readonly v-model="forms.dateFrom")
            v-date-picker(v-model="forms.dateFrom" @input="calendar1 = false")
        v-col.d-flex.pl-11.pl-sm-0(cols="12" sm="4" md="4")
          v-menu(offset-y transition="scale-transition" :nudge-right="40" min-width="290px" :close-on-content-click="false" v-model="calendar2")
            template(v-slot:activator="{on}")
              v-text-field(hide-details :label="$t('checkout.label')" v-on="on" readonly v-model="forms.dateTo")
            v-date-picker(v-model="forms.dateTo" @input="calendar2 = false")

        //- 荷物数
        v-col.d-flex(cols="12" sm="4" md="4")
          v-select(hide-details :label="$t('luggage.label')" prepend-icon="fa-suitcase-rolling" :items="luggageList" v-model="forms.luggage")

        //- 検索ボタン
        v-col.d-flex.align-end(cols="12" sm="5" md="4")
          v-btn(block ref="submit" color="primary" @click="search")|{{$t('submit')}}
</template>

<script>
export default {
  data () {
    return {
      // 入力フォーム
      forms: {
        area1: null,
        area2: null,
        area3: null,
        dateFrom: null,
        dateTo: null,
        luggage: null
      },
      // カレンダー１
      calendar1: false,
      // カレンダー２
      calendar2: false,
      // Flowモード有無
      isFlow: false
    }
  },
  created () {
    this.forms = this.utils.array.clone(this.$store.getters.forms_search)
  },
  mounted () {
    this.onScroll()
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  computed: {
    /**
     * エリアリスト１
     */
    areaList1 () {
      const list = [
        {
          areaId: 0,
          parentAreaId: null,
          areaName: this.$t('area.present'),
          mapLatitude: 0,
          mapLongitude: 0,
          childeren: null
        }
      ]
      return list.concat(this.$store.getters.area_list)
    },
    /**
     * エリアリスト２
     */
    areaList2 () {
      if (!this.forms.area1 || !this.forms.area1.children) {
        return []
      }

      return this.forms.area1.children
    },
    /**
     * エリアリスト３
     */
    areaList3 () {
      if (!this.forms.area2 || !this.forms.area2.children) {
        return []
      }

      return this.forms.area2.children
    },
    /**
     * 荷物数リスト
     */
    luggageList () {
      return [...Array(10).keys()].map(i => {
        let num = ++i
        return {
          value: num,
          text: this.utils.cast.string(num) + this.$t('luggage.unit')
        }
      })
    }
  },
  watch: {
    /**
     * エリア１
     */
    'forms.area1' () {
      this.forms.area2 = null
      this.forms.area3 = null
    },
    /**
     * エリア２
     */
    'forms.area2' () {
      this.forms.area3 = null
    }
  },
  methods: {
    /**
     * エリアデータを取得
     */
    getAreaData () {
      let area = null
      if (this.areaList2.length === 0) {
        area = this.forms.area1
      } else if (this.areaList3.length === 0) {
        area = this.forms.area2 || this.areaList2[0]
      } else {
        area = this.forms.area3 || this.areaList3[0]
      }

      if (!area) {
        return null
      }

      return area
    },
    /**
     * 検索
     */
    search () {
      const data = this.utils.array.clone(this.forms)
      data.areaData = this.getAreaData()
      this.$store.commit('forms_set_search', data)
      this.$router.push({name: 'MapShopList'})
    },
    /**
     * 画面のスクロール時
     */
    onScroll (ev) {
      const headHeight = 48
      let rect = this.$refs.submit.$el.getBoundingClientRect()
      this.isFlow = (rect.top - headHeight <= 0)
    }
  }
}
</script>

<style lang="sass" scoped>
.search
  box-sizing: border-box
  width: 100%
  margin: 8 0 0 8
  padding: 0

  &-content
    box-sizing: border-box
    width: 100%
    margin: 0
    padding: 0

// @media (min-width: 740px)
//   .search
//     position: absolute
//     top: 0
//     left: 0
//     height: 100%

//     &-container
//       position: fixed
//       top: 8px
//       left: 2px
//       z-index: 2
//       margin: 44px 0 0 0
//       border-radius: 10px
//       background: #00000088

//     &-content
//       height: 100%
//       padding: 5px
//       border-radius: 8px
//       background: #ffffff
</style>
